import { Page } from '@/core/architecture'

import { ConsolePostEditTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsolePostEdit Page
 * Implemented as a practical sample.
 */
export const ConsolePostEdit: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsolePostEditTemplate state={state} {...actions} />
}
